import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../shared/abstract/component.service';
import { RoleEnums } from '../../shared/enum/authorize';
import { AuthService } from '../../shared/auth/auth.service';
import { AdminService } from './admin.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { RequestService } from '../../shared/services/request.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css',
})
export class AdminComponent extends ComponentService<any> implements OnInit {
  subscription!: Subscription;
  @Output() userInfos;
  private mobileQueryListener: () => void;
  public mobileQuery: MediaQueryList;
  userType;
  projects: any = [];
  isLoaded = true;
  roleEnums = RoleEnums;

  constructor(
    injector: Injector,
    private route: ActivatedRoute,
    private _router: Router,
    private _auth: AuthService,
    private _adminService: AdminService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private _request: RequestService
  ) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
  }

  ngOnInit(): void {
    //initialize userInfos variable in appsService
    if (this.mobileQuery.matches) {
      this._appsService.mobileScreen = true;
    } else {
      this._appsService.mobileScreen = false;
    }
    this.userInfos = this._appsService.userInfo();
    this.subscription = this._appsService.projectData.subscribe((res) => {
      if (res) {
        this.onSelectedProject(res);
      }
    });

    this._auth.authControl(localStorage.getItem('ut'));
    if (this.userInfos.RoleId != null) {
      if (
        [
          RoleEnums.SuperAdmin,
          RoleEnums.Admin,
          RoleEnums.CompanyAdmin,
        ].includes(this.userInfos.RoleId)
      ) {
        this.adminInit();
      } else {
        this.userInit();
        if (RoleEnums.Supervisor == this.userInfos.RoleId) {
          this.userType = RoleEnums.Supervisor;
        }
        if (RoleEnums.TeamLeader == this.userInfos.RoleId) {
          this.userType = RoleEnums.TeamLeader;
        }
        if (RoleEnums.LdapUser == this.userInfos.RoleId) {
          this.userType = RoleEnums.LdapUser;
        }
      }
    }
    //this._appsService.sidebarData.subscribe((res) => {
    //  if (res) {
    //    this.sideList = res;
    //  }
    //});

    //this._router.navigate(['application/dashboard/']);
  }

  onSelectedProject(projectId: number) {
    this._adminService.setCurrentProject(projectId).then((_) => {
      const p = this.projects.find((p) => p.id == projectId);
      p != null ? this._appsService.getCurrentProject(p) : false;
      this._appsService.getSettings();
      this.isLoaded = false;
    });
  }

  adminInit() {
    this._appsService
      .getUserInfoRequest()
      .then((_) => {
        //this.themeControl(_.theme);
      })
      .finally(() => {
        if (
          this._appsService.userInfos.role ==
            this.roleEnums[this.roleEnums.Admin] ||
          this._appsService.userInfos.role ==
            this.roleEnums[this.roleEnums.SuperAdmin]
        ) {
          this.userType = this.roleEnums.Admin;
          this._adminService
            .getCompanies()
            .then((_) => {
              if (_) {
                this._appsService.companies = _;
                this._appsService.companies.sort(this.turkishSortCompany);
                this._appsService.filterCompanies = JSON.parse(
                  JSON.stringify(this._appsService.companies)
                );
                this._appsService.companies = this._appsService.companies;
                if (this._appsService.userInfos.lastCompanyId) {
                  this._appsService.selectedCompany =
                    this._appsService.userInfos.lastCompanyId;
                  this._appsService.existCurrentCompany =
                    this._appsService.userInfos.lastCompanyId;
                  this.onSelectedCompany(
                    this._appsService.userInfos.lastCompanyId
                  );
                } else {
                  this._appsService.selectedCompany =
                    this._appsService.companies[0].id;
                  this.onSelectedCompany(this._appsService.companies[0].id);
                  this._appsService.existCurrentCompany =
                    this._appsService.companies[0].id;
                }
                this._request
                  .getCompanyWithoutAuth(this._appsService.existCurrentCompany)
                  .then((_) => {
                    this._appsService.userLayers = _.layer;
                  });
                localStorage.setItem('cId', this._appsService.selectedCompany);
              }
            })
            .finally(() => {
              this._appsService.isAdmin = true;
              //this.isLoaded = false;
              //this.getSideList();
            });
        } else if (
          this._appsService.userInfos.role ==
          this.roleEnums[this.roleEnums.CompanyAdmin]
        ) {
          this.userType = this._appsService.userInfos.roleId;
          this._appsService.isAdmin = false;
          localStorage.setItem('cId', this._appsService.userInfos.companyId);
          this._appsService.selectedCompany =
            this._appsService.userInfos.companyId;
          this._appsService.existCurrentCompany =
            this._appsService.userInfos.companyId;
          this._request
            .getProjects(this._appsService.userInfos.companyId)
            .then((_) => {
              this.projects = _;
              this.projects.sort(this.turkishSortProject);
              this.subProjectControl(this.projects);
              this._appsService.projects = this.projects;
              this.projects.forEach((p) => {
                p.projectId = p.id;
              });
              if (this.projects.length > 1) {
                if (this._appsService.userInfos.lastProjectId) {
                  this._appsService.selectedProject =
                    this._appsService.userInfos.lastProjectId;
                  this.onSelectedProject(
                    this._appsService.userInfos.lastProjectId
                  );
                } else {
                  this._appsService.selectedProject =
                    this.projects[0].projectId;
                  this.onSelectedProject(this.projects[0].projectId);
                }
              } else {
                this._appsService.selectedProject = this.projects[0].projectId;
                this.onSelectedProject(this.projects[0].projectId);
              }
            })
            .finally(() => {
              if (this.projects.length != 0) {
                this._appsService.isLoaded = true;
              } else {
                this._appsService.isLoaded = false;
                this.projects = [];
                this.MessageBox(
                  this.languageKey('companyOwnedProjectNotFound'),
                  'orange',
                  'center'
                );
              }
              //this.checkAppObjRule();
              //this.checkVrpRule();
              //this.getAllWorkRules();
              //this.getPoiCategories();
              //this.getSideList();
              //this.setUserLayers();
            });
        }
      });
  }

  onSelectedCompany(companyId: number) {
    this._appsService.projects = [];
    this._request
      .setCurrentCompany(companyId)
      .then((_) => {
        if (_.code == 1) {
          this._appsService.existCurrentCompany = companyId;
          localStorage.setItem('cId', companyId.toString());
        } else if (_.code == 2) {
          this.MessageBox(_.message ?? '', 'orange', 'center');
        } else {
          this.MessageBox(_.message ?? '', 'warn', 'center');
        }
      })
      .finally(() => {
        this._appsService.selectedCompany = companyId;
        this._appsService.existCurrentCompany = companyId;
        this._request
          .getProjects(companyId)
          .then((_) => {
            this.projects = _;
            this.projects.sort(this.turkishSortProject);
            this.subProjectControl(this.projects);
            if (_) {
              this.projects.forEach((p) => {
                p.projectId = p.id;
              });
              this._appsService.selectedProject = this._appsService.userInfos
                .lastProjectId
                ? this._appsService.userInfos.lastProjectId
                : this.projects[0].id;
            }
            this._appsService.projects = this.projects;
          })
          .finally(() => {
            if (this.projects.length != 0) {
              //this.onSelectedProject(this.projects[0].id)
              //burada kullanıcın last project Id'sı setlenmeli
              this.onSelectedProject(
                this._appsService.userInfos.lastProjectId
                  ? this._appsService.userInfos.lastProjectId
                  : this._appsService.userInfos.lastProjectId
              );

              //this.checkAppObjRule();
              //this.getAllWorkRules();
              //this.checkVrpRule();
              //this.getPoiCategories();
              //this.setUserLayers();
              this._appsService.isLoaded = true;
            } else {
              this._appsService.isLoaded = false;
              this.projects = [];
              this.isLoaded = false;
              //this._appsService.getCurrentProject(null)
              this.MessageBox(
                this.languageKey('companyOwnedProjectNotFound'),
                'orange',
                'center'
              );
            }
          });
      });
  }

  subProjectControl(projects) {
    let p: any = [];
    projects.forEach((project) => {
      p.push(project);
      if (project.inverseParent.length != 0) {
        project.inverseParent.sort(this.turkishSortProject);
        p.push(...project.inverseParent);
      }
    });
    this.projects = p;
  }

  async userInit() {
    this._appsService
      .getUserInfoRequest()
      .then(async (_) => {
        this._appsService.isAdmin = false;
        this._appsService.existCurrentCompany = _.companyId;
        this._request.getCompany(_.companyId).then((_) => {
          this._appsService.userLayers = _.layer;
        });
        this._appsService.selectedCompany = _.companyId;
        localStorage.setItem('cId', _.companyId?.toString() ?? '');
        this._appsService.userInfos = _;
        this.projects = _.userProjects;
        let p: any = [];
        this.projects.forEach((project) => {
          p.push(project);
          if (project.subProjects.length != 0) {
            project.subProjects.forEach((p) => {
              p.authorizations = project.authorizations;
            });
            p.push(...project.subProjects);
          }
        });
        this.projects = p;
        this._appsService.projects = this.projects;
        if (_.lastProjectId) {
          this._appsService.selectedProject = _.lastProjectId;
        } else {
          this._appsService.selectedProject = this.projects[0].projectId;
          this._appsService.userInfos.projectId = this.projects[0].projectId;
        }
        await this._appsService.getCurrentProject(
          this.projects.find(
            (p) => p.projectId == this._appsService.selectedProject
          )
        );
      })
      .finally(() => {
        if (this.projects?.length > 0) {
          //this.getSideList();
          //this.checkAppObjRule();
          //this.getAllWorkRules();
          //this.checkVrpRule();
          //this.getPoiCategories();
          //this._appsService.getSettings();
          //this.setUserLayers();
        } else {
          this.MessageBox(
            this.languageKey('noUSerAssignToProject'),
            'orange',
            'center'
          );
          this._router.navigate(['account/login']);
        }
      });
  }
}
